import React from "react";
//npm install --save react-router-dom
import { Link, withRouter } from "react-router-dom";
import HeadRight from "./image/g13.png";
import HeadLeft from "./image/defense.jpg";
import DataSender from "./lib/DataSender";
import { withAlert } from "react-alert";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: "",
      password: "",
    };

    this.alert = this.props.alert;
    this.Login = this.Login.bind(this);
    this.ds = new DataSender();
  }

  handlePress = (e) => {
    if (e.key === "Enter") {
      this.Login();
    }
  };

  componentDidMount() {
    this.ds
      .checkLogin()
      .then((x) => x.json())
      .then((x) => {
        if (x.permission === "M") this.props.history.push("/Main");
        if (x.permission === "T") this.props.history.push("/MainTrain");
        if (x.permission === "A")
          this.props.history.push({
            pathname: "/Manager",
            state: { name: x.name },
          });
      })
      .catch(() => {});
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  Login() {
    const { userId, password } = this.state;
    if (userId === null || userId.length < 1) {
      // eslint-disable-next-line react/style-prop-object
      this.alert.show("아이디를 입력해주세요");
      return;
    }
    if (password === null || password.length < 1) {
      this.alert.show("비밀번호를 입력해주세요");
      return;
    }
    this.ds
      .login({ userId, password })
      .then((x) => x.json())
      .then((x) => {
        this.alert.show("로그인에 성공하셨습니다.");
        if (x.permission === "M") this.props.history.push("/Main");
        if (x.permission === "T") this.props.history.push("/MainTrain");
        if (x.permission === "A")
          this.props.history.push({
            pathname: "/Manager",
            state: { name: x.name },
          });
      })
      .catch((e) => {
        this.alert.show("아이디 혹은 비밀번호가 일치하지 않습니다.");
      });
  }

  render() {
    return (
      <div className="main-login">
        <div className="container" id="container">
          <div className="form-container">
            <div className="main-login-form">
              <h1>로그인</h1>
              <div className="main-login-form-container">
                <input
                  type="email"
                  placeholder="Id"
                  name="userId"
                  onChange={this.handleChange}
                />
                <input
                  type="password"
                  placeholder="Password"
                  name="password"
                  onChange={this.handleChange}
                  onKeyPress={this.handlePress}
                />
                <button onClick={this.Login}>로그인</button>
              </div>
              <div className="main-login-form-link">
                <Link to="/#" className="main-login-link">
                  <p>관련 사이트 보기</p>
                </Link>
              </div>
            </div>
          </div>
          <div className="overlay-container">
            <div className="overlay">
              <div className="overlay-panel overlay-right">
                <h2>국방지능형훈련관리플랫폼</h2>
                <p>
                  군장병분들의 체력 측정 및 신원 확인을 도와주는 프로그램입니다.
                </p>
                <div className="main-logo">
                  <img src={HeadLeft} alt="로고" />
                  <img src={HeadRight} className="second" alt="로고" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withAlert()(withRouter(Login));
